import ContactNavigation from "./ContactNavigation";
import NavbarProps from "../Props/NavbarProps";
import { LogoNavbar, nav } from "../../data";
import NavbarMobile from "./NavbarMobile";
import Logo from "../Logo";

function Navbar() {
  return (
    <nav className="nav-parent-container container">
      <ContactNavigation />
      <div className="navbar-container container">
        <Logo data={LogoNavbar} />
        <div className="navbar">
          <NavbarProps data={nav} />
        </div>
      </div>
      <NavbarMobile />
    </nav>
  );
}

export default Navbar;
